import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  CssBaseline, CircularProgress, Container, Grid, Box,
  Typography, TextField, Switch, FormControlLabel,
  Select, MenuItem, FormControl, InputLabel,
  Button, IconButton, Divider, Chip, Paper,
  Tooltip, Collapse, Radio, RadioGroup,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as componentActions from '../../redux/actions/users';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  DragIndicator as DragIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  BookmarkBorderOutlined as DefaultIcon,
  Bookmark as DefaultIconFilled,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material';
import {
  getBoardById,
  createBoard,
  updateBoard,
  setDefaultBoard,
  getAvailableStatuses,
  getFilterMetadata,
} from '../../services/kanban.service';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Api from '../../services/api';
import * as CalledService from '../../services/called.service';
import RealSimpleAutoComplete from '../../components/auto-complete/autocomplete-with-onclick';
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple';


/*const GROUP_BY_OPTIONS = [
  { value: 'NONE',                  label: 'Sem agrupamento' },
  { value: 'ORGANIZATION',          label: 'Por organização' },
  { value: 'ORGANIZATION_CATEGORY', label: 'Por organização e categoria' },
  { value: 'ASSIGNED_USER',         label: 'Por responsável' },
  { value: 'PRIORITY',              label: 'Por prioridade' },
];*/

const newColumn = (order) => ({
  _tempId:  Date.now() + order,
  id:       null,
  name:     `Coluna ${order}`,
  order,
  colorHex: '#6b7280',
  statuses: [],
});

const newFilterGroup = () => ({
  _tempId:         Date.now(),
  id:              null,
  logicalOperator: 'AND',
  order:           1,
  conditions:      [],
});

const newCondition = () => ({
  _tempId:             Date.now() + Math.random(),
  id:                  null,
  conditionCriteriaId: null,
  operatorId:          1,
  value:               [],
  logicalOperator:     'AND',
  organizationId:      null,
  categoryList:        [],
});

const getStatusConflictMessage = (col, status, intl) => {
  const alreadySelected = col.statuses.some(s => s.statusId === status.id);
  if (alreadySelected) return null;

  const existingTypeIds = col.statuses.map(s => s.statusTypeId);
  const newTypeId = status.statusTypeId;

  const hasClosedOrResolved = existingTypeIds.some(t => t === 5 || t === 9);
  const hasCanceled          = existingTypeIds.some(t => t === 4);
  const hasOther             = existingTypeIds.some(t => t != null && t !== 5 && t !== 9 && t !== 4);

  if (hasClosedOrResolved && !(newTypeId === 5 || newTypeId === 9))
    return intl.formatMessage({ id: 'kanban.column.status.conflict.closed' });
  if (hasCanceled && newTypeId !== 4)
    return intl.formatMessage({ id: 'kanban.column.status.conflict.canceled' });
  if (hasOther && (newTypeId === 5 || newTypeId === 9))
    return intl.formatMessage({ id: 'kanban.column.status.conflict.closed' });
  if (hasOther && newTypeId === 4)
    return intl.formatMessage({ id: 'kanban.column.status.conflict.canceled' });

  return null;
};

class KanbanBoardEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      saving:  false,
      openNotification:    false,
      notificationVariant: 'error',
      notificationMessage: '',

      id:                    null,
      title:                 '',
      active:                true,
      isDefault:             false,
      groupBy:               'NONE',
      filterLogicalOperator: 'AND',
      columns:               [],
      filters:               [],

      availableStatuses: [],
      filterFields:      [],
      filterOperators:   [],

      // Filter entity lists (lazy-loaded on focus)
      statusFilterList:        [],  loadingStatusFilter:        false,
      priorityFilterList:      [],  loadingPriorityFilter:      false,
      typeFilterList:          [],  loadingTypeFilter:           false,
      originFilterList:        [],  loadingOriginFilter:         false,
      groupFilterList:         [],  loadingGroupFilter:          false,
      organizationsFilterList: [],  loadingOrganizationFilter:  false,
      assignedUserFilterList:  [],  loadingAssignedUserFilter:  false,

      filtersOpen:   true,
      columnWarning: '',

      shareMode:        1,
      sharedUserIds:    [],
      sharedTeamIds:    [],
      userShareList:    [],
      teamShareList:    [],
      loadingUserShare: false,
      loadingTeamShare: false,
      isTechnical:      false,
    };

    this.handleSave        = this.handleSave.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.handleSetDefault  = this.handleSetDefault.bind(this);
    this.columnsEndRef     = React.createRef();
    this._colorTimer       = null;
  }

  mapConditionFromApi = (c) => ({
    _tempId:             c.id,
    id:                  c.id,
    conditionCriteriaId: c.automationconditioncriteriaid,
    operatorId:          1,
    value:               c.values?.[0] ? c.values[0].split(',').map(Number) : [],
    logicalOperator:     c.logicaloperator ?? 'AND',
    organizationId:      null,
    categoryList:        [],
  });

  async componentDidMount() {
    const { match } = this.props;
    const boardId   = match?.params?.id;

    const { userSession } = this.props;
    let isTechnical = false;
    if (userSession?.user) {
      const roles = userSession.user.userrole ?? [];
      const isGlobalAdmin    = roles.some(r => r.role?.roletype === 0);
      const isAdminOrCoord   = roles.some(r => r.role?.roletype === 1 || r.role?.roletype === 4);
      isTechnical = !isGlobalAdmin && !isAdminOrCoord;
    }
    this.setState({ isTechnical });

    try {
      const [statusesRes, metaRes] = await Promise.all([
        getAvailableStatuses(),
        getFilterMetadata(),
      ]);

      const availableStatuses = (statusesRes.data?.data ?? []).map(s => ({
        ...s,
        statusTypeId: s.statustypeid ?? s.statusTypeId ?? null,
      }));
      const filterFields      = metaRes.data?.data?.fields    ?? [];
      const filterOperators   = metaRes.data?.data?.operators ?? [];

      if (boardId) {
        const boardRes = await getBoardById(boardId);
        const board    = boardRes.data?.data;
        if (board) {
          const mappedFilters = (board.filters ?? []).map((f) => ({
            ...f,
            _tempId:         f.id,
            logicalOperator: f.logicaloperator,
            conditions:      (f.conditions ?? []).map(this.mapConditionFromApi),
          }));

          this.setState({
            id:                    board.id,
            title:                 board.title,
            active:                board.active,
            isDefault:             board.isdefault ?? false,
            groupBy:               board.groupby,
            filterLogicalOperator: board.filterlogicaloperator,
            shareMode:             board.sharemode    ?? 4,
            sharedUserIds:         board.shareduserids ?? [],
            sharedTeamIds:         board.sharedteamids ?? [],
            columns:               (board.columns ?? []).map((c) => ({
              ...c,
              _tempId:  c.id,
              colorHex: c.colorhex,
              statuses: (c.statuses ?? []).map((s) => ({ ...s, _tempId: s.id, statusId: s.statusid, statusTypeId: s.statustypeid ?? s.statusTypeId ?? null })),
            })),
            filters:               mappedFilters,
            availableStatuses,
            filterFields,
            filterOperators,
            loading: false,
          });

          const usedCriteria = new Set(
            mappedFilters.flatMap(f => f.conditions.map(c => c.conditionCriteriaId).filter(Boolean))
          );
          const CRITERIA_LOADERS = {
            5:  this.getFilterType,
            6:  this.getFilterPriority,
            7:  this.getFilterStatus,
            8:  this.getFilterOrigin,
            9:  this.getFilterGroup,
            10: this.getFilterOrganizations,
            11: this.getFilterOrganizations,
            12: this.getFilterAssignedUser,
          };
          await Promise.all([...usedCriteria].map(id => CRITERIA_LOADERS[id]?.()));

          const case11Items = [];
          mappedFilters.forEach((f) => {
            f.conditions.forEach((c) => {
              if (c.conditionCriteriaId === 11 && Array.isArray(c.value) && c.value.length > 0) {
                case11Items.push({ filterTempId: f._tempId, condTempId: c._tempId, categoryId: c.value[0] });
              }
            });
          });

          if (case11Items.length > 0) {
            await this.getFilterOrganizations();
            for (const item of case11Items) {
              const catResult = await CalledService.getCategoryById(item.categoryId);
              if (catResult?.success) {
                const orgId = catResult.data?.organization;
                if (orgId) {
                  this.updateCondition(item.filterTempId, item.condTempId, 'organizationId', orgId);
                  await this.getFilterCategoriesByOrg(orgId, item.filterTempId, item.condTempId);
                }
              }
            }
          }

          return;
        }
      }

      this.setState({
        columns:           [newColumn(1), newColumn(2), newColumn(3)],
        availableStatuses,
        filterFields,
        filterOperators,
        loading: false,
      });
    } catch (err) {
      this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: 'Erro ao carregar dados.' });
    }
  }

  async handleSave() {
    const { title } = this.state;
    if (!title.trim()) {
      this.setState({ openNotification: true, notificationVariant: 'error', notificationMessage: 'O título do quadro é obrigatório.' });
      return;
    }

    if (title.trim().length > 150) {
      this.setState({ openNotification: true, notificationVariant: 'error', notificationMessage: this.props.intl.formatMessage({ id: 'kanban.board.title.max.length' }) });
      return;
    }

    const columnsWithNoStatus = this.state.columns.filter(c => c.statuses.length === 0);
    if (columnsWithNoStatus.length > 0) {
      this.setState({ openNotification: true, notificationVariant: 'error', notificationMessage: 'Todas as colunas devem ter ao menos um status selecionado.' });
      return;
    }

    this.setState({ saving: true });
    const payload = {
      title:                 this.state.title,
      active:                this.state.active,
      groupBy:               this.state.groupBy,
      filterLogicalOperator: this.state.filterLogicalOperator,
      shareMode:             this.state.shareMode,
      userIds:               this.state.shareMode === 2 ? this.state.sharedUserIds : [],
      teamIds:               this.state.shareMode === 3 ? this.state.sharedTeamIds : [],
      columns:               this.state.columns,
      filters:               this.state.filters.map((f, fi) => ({
        id:              f.id ?? null,
        logicalOperator: f.logicalOperator,
        sortOrder:       fi + 1,
        conditions:      f.conditions.map((c) => ({
          id:                            c.id ?? null,
          automationConditionCriteriaId: c.conditionCriteriaId,
          automationOperatorId:          1,
          logicalOperator:               c.logicalOperator ?? 'AND',
          values:                        Array.isArray(c.value) && c.value.length > 0 ? [c.value.join(',')] : [],
        })),
      })),
    };

    try {
      if (this.state.id) {
        await updateBoard(this.state.id, payload);
        if (this.state.isDefault) {
          await setDefaultBoard(this.state.id);
        }
      } else {
        const res = await createBoard(payload);
        const newId = res?.data?.data?.id;
        if (this.state.isDefault && newId) {
          await setDefaultBoard(newId);
        }
      }
      this.setState({ saving: false, openNotification: true, notificationVariant: 'success', notificationMessage: this.props.intl.formatMessage({ id: 'kanban.board.save.success' }) });
      setTimeout(() => this.goBack(), 1200);
    } catch (err) {
      this.setState({ saving: false, openNotification: true, notificationVariant: 'error', notificationMessage: 'Erro ao salvar o quadro.' });
    }
  }

  handleSetDefault() {
    this.setState((prev) => ({ isDefault: !prev.isDefault }));
  }

  goBack() {
    const { match, history } = this.props;
    const lang = match?.params?.lang ?? 'pt';
    history.push(`/${lang}/kanban`);
  }

  closeNotification() {
    this.setState({ openNotification: false });
  }

  addColumn = () => {
    const { columns } = this.state;
    this.setState({ columns: [...columns, newColumn(columns.length + 1)] }, () => {
      this.columnsEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    });
  };

  removeColumn = (tempId) => {
    this.setState((prev) => ({ columns: prev.columns.filter((c) => c._tempId !== tempId) }));
  };

  updateColumn = (tempId, field, value) => {
    this.setState((prev) => ({
      columns: prev.columns.map((c) => (c._tempId === tempId ? { ...c, [field]: value } : c)),
    }));
  };

  toggleColumnStatus = (colTempId, status) => {
    const col = this.state.columns.find(c => c._tempId === colTempId);
    if (!col) return;

    const conflictMsg = getStatusConflictMessage(col, status, this.props.intl);
    if (conflictMsg) {
      this.setState({ columnWarning: conflictMsg });
      return;
    }

    this.setState((prev) => ({
      columns: prev.columns.map((c) => {
        if (c._tempId !== colTempId) return c;
        const already = c.statuses.some((s) => s.statusId === status.id);
        const statuses = already
          ? c.statuses.filter((s) => s.statusId !== status.id)
          : [...c.statuses, { _tempId: Date.now(), id: null, statusId: status.id, statusName: status.name, colorHex: status.colorHex, statusTypeId: status.statusTypeId ?? null, order: c.statuses.length + 1 }];
        return { ...c, statuses };
      }),
    }));
  };

  onColumnDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    if (source.index === destination.index) return;
    const next = [...this.state.columns];
    const [moved] = next.splice(source.index, 1);
    next.splice(destination.index, 0, moved);
    next.forEach((c, i) => { c.order = i + 1; });
    this.setState({ columns: next });
  };

  addFilterGroup = () => {
    this.setState((prev) => ({ filters: [...prev.filters, newFilterGroup()] }));
  };

  removeFilterGroup = (tempId) => {
    this.setState((prev) => ({ filters: prev.filters.filter((f) => f._tempId !== tempId) }));
  };

  updateFilterGroup = (tempId, field, value) => {
    this.setState((prev) => ({
      filters: prev.filters.map((f) => (f._tempId === tempId ? { ...f, [field]: value } : f)),
    }));
  };

  addCondition = (groupTempId) => {
    this.setState((prev) => ({
      filters: prev.filters.map((f) => {
        if (f._tempId !== groupTempId) return f;
        return { ...f, conditions: [...f.conditions, newCondition()] };
      }),
    }));
  };

  removeCondition = (groupTempId, condTempId) => {
    this.setState((prev) => ({
      filters: prev.filters.map((f) => {
        if (f._tempId !== groupTempId) return f;
        return { ...f, conditions: f.conditions.filter((c) => c._tempId !== condTempId) };
      }),
    }));
  };

  updateCondition = (groupTempId, condTempId, field, value) => {
    this.setState((prev) => ({
      filters: prev.filters.map((f) => {
        if (f._tempId !== groupTempId) return f;
        return {
          ...f,
          conditions: f.conditions.map((c) => {
            if (c._tempId !== condTempId) return c;
            const extra = {};
            if (field === 'conditionCriteriaId') {
              extra.value = [];
              extra.organizationId = null;
              extra.categoryList = [];
            }
            return { ...c, [field]: value, ...extra };
          }),
        };
      }),
    }));
  };

  getFilterStatus = async () => {
    if (this.state.statusFilterList.length > 0 || this.state.loadingStatusFilter) return;
    this.setState({ loadingStatusFilter: true });
    try {
      const result = await CalledService.getStatusDapper();
      if (result.success) {
        this.setState({ statusFilterList: result.data ?? [] });
      }
    } catch {}
    this.setState({ loadingStatusFilter: false });
  };

  getFilterPriority = async () => {
    if (this.state.priorityFilterList.length > 0 || this.state.loadingPriorityFilter) return;
    this.setState({ loadingPriorityFilter: true });
    try {
      const result = await CalledService.getPriority();
      if (result.success) {
        this.setState({ priorityFilterList: result.data ?? [] });
      }
    } catch {}
    this.setState({ loadingPriorityFilter: false });
  };

  getFilterType = async () => {
    if (this.state.typeFilterList.length > 0 || this.state.loadingTypeFilter) return;
    this.setState({ loadingTypeFilter: true });
    try {
      const result = await CalledService.getTypesDapper();
      if (result.success) {
        this.setState({ typeFilterList: result.data ?? [] });
      }
    } catch {}
    this.setState({ loadingTypeFilter: false });
  };

  getFilterOrigin = async () => {
    if (this.state.originFilterList.length > 0 || this.state.loadingOriginFilter) return;
    this.setState({ loadingOriginFilter: true });
    try {
      const result = await CalledService.getOriginRequestsDapper();
      if (result.success) {
        this.setState({ originFilterList: result.data ?? [] });
      }
    } catch {}
    this.setState({ loadingOriginFilter: false });
  };

  getFilterGroup = async () => {
    if (this.state.groupFilterList.length > 0 || this.state.loadingGroupFilter) return;
    this.setState({ loadingGroupFilter: true });
    try {
      const result = await CalledService.getGroups();
      if (result.success) {
        this.setState({ groupFilterList: result.data ?? [] });
      }
    } catch {}
    this.setState({ loadingGroupFilter: false });
  };

  getFilterOrganizations = async () => {
    if (this.state.organizationsFilterList.length > 0 || this.state.loadingOrganizationFilter) return;
    this.setState({ loadingOrganizationFilter: true });
    try {
      const result = await CalledService.getOrganizationsDapper();
      if (result.success) {
        const sorted = (result.data ?? []).filter(o => o.active).sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
        this.setState({ organizationsFilterList: sorted });
      }
    } catch {}
    this.setState({ loadingOrganizationFilter: false });
  };

  getFilterAssignedUser = async () => {
    if (this.state.assignedUserFilterList.length > 0 || this.state.loadingAssignedUserFilter) return;
    this.setState({ loadingAssignedUserFilter: true });
    try {
      const result = await CalledService.getTechinicalUsersDapper();
      if (result.success) {
        const sorted = (result.data ?? []).sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
        this.setState({ assignedUserFilterList: sorted });
      }
    } catch {}
    this.setState({ loadingAssignedUserFilter: false });
  };

  getShareUsers = async () => {
    if (this.state.userShareList.length > 0 || this.state.loadingUserShare) return;
    this.setState({ loadingUserShare: true });
    try {
      const result = await Api.get('/users/search/technician');
      if (result.data?.success) {
        const sorted = (result.data.data ?? []).sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
        this.setState({ userShareList: sorted });
      }
    } catch {}
    this.setState({ loadingUserShare: false });
  };

  getShareTeams = async () => {
    if (this.state.teamShareList.length > 0 || this.state.loadingTeamShare) return;
    this.setState({ loadingTeamShare: true });
    try {
      const result = await CalledService.getFilterTechinicalTeamDapper();
      if (result.success) {
        const sorted = (result.data ?? []).sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
        this.setState({ teamShareList: sorted });
      }
    } catch {}
    this.setState({ loadingTeamShare: false });
  };

  getFilterCategoriesByOrg = async (organizationId, groupTempId, condTempId) => {
    if (!organizationId) return;
    try {
      const result = await CalledService.getCategoriesByOrganizationDapper(organizationId);
      const sorted = Array.isArray(result?.data)
        ? [...result.data].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
        : [];
      this.setState((prev) => ({
        filters: prev.filters.map((f) => {
          if (f._tempId !== groupTempId) return f;
          return {
            ...f,
            conditions: f.conditions.map((c) =>
              c._tempId === condTempId ? { ...c, categoryList: sorted } : c
            ),
          };
        }),
      }));
    } catch {}
  };

  renderSectionTitle = (label) => (
    <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, color: 'text.primary' }}>
      {label}
    </Typography>
  );

  renderColumnCard = (col, provided, snapshot) => {
    const { availableStatuses } = this.state;
    return (
      <Paper
        ref={provided.innerRef}
        {...provided.draggableProps}
        variant="outlined"
        sx={{
          p: 2, mb: 2, borderRadius: 2, position: 'relative',
          ...(snapshot.isDragging ? { boxShadow: 6, opacity: 0.95 } : {}),
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
          <Box
            component="span"
            {...provided.dragHandleProps}
            sx={{ display: 'flex', alignItems: 'center', cursor: 'grab', color: 'text.disabled' }}
          >
            <DragIcon />
          </Box>

          <TextField
            label="Nome da coluna"
            size="small"
            value={col.name}
            onChange={(e) => this.updateColumn(col._tempId, 'name', e.target.value)}
            sx={{ flex: 1 }}
          />

          <input
            type="color"
            key={col._tempId}
            defaultValue={col.colorHex}
            onChange={(e) => {
              const value = e.target.value;
              clearTimeout(this._colorTimer);
              this._colorTimer = setTimeout(() => this.updateColumn(col._tempId, 'colorHex', value), 150);
            }}
            style={{ width: 36, height: 36, border: 'none', cursor: 'pointer', borderRadius: 4, padding: 2 }}
            title="Cor da coluna"
          />

          <Tooltip title="Remover coluna">
            <IconButton size="small" color="error" onClick={() => this.removeColumn(col._tempId)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
          Status nesta coluna (selecione um ou mais):
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
          {availableStatuses.map((st) => {
            const selected = col.statuses.some((s) => s.statusId === st.id);
            const conflictMsg = selected ? null : getStatusConflictMessage(col, st, this.props.intl);
            const blocked = Boolean(conflictMsg);
            return (
              <Tooltip key={st.id} title={conflictMsg ?? ''} disableHoverListener={!conflictMsg}>
                <span style={{ display: 'inline-flex' }}>
                  <Chip
                    label={st.name}
                    size="small"
                    color={selected ? 'primary' : 'default'}
                    onClick={() => this.toggleColumnStatus(col._tempId, st)}
                    sx={{
                      cursor:      blocked ? 'not-allowed' : 'pointer',
                      fontWeight:  selected ? 'bold' : 'normal',
                      bgcolor:     selected ? undefined : blocked ? '#f3f4f6' : '#f3f4f6',
                      color:       selected ? undefined : blocked ? '#b0b7c3' : '#374151',
                      border:      '1.5px solid',
                      borderColor: selected ? 'primary.main' : blocked ? '#d1d5db' : '#e5e7eb',
                      opacity:     blocked ? 0.5 : 1,
                      pointerEvents: 'auto',
                      '&:hover':   { opacity: blocked ? 0.5 : 0.85 },
                      '& .MuiChip-label': { textDecoration: blocked ? 'line-through' : 'none' },
                    }}
                  />
                </span>
              </Tooltip>
            );
          })}
        </Box>

        {col.statuses.length === 0 && (
          <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
            Selecione ao menos um status.
          </Typography>
        )}
      </Paper>
    );
  };

  renderConditionValue = (groupTempId, cond) => {
    const { conditionCriteriaId: criteriaId } = cond;

    const setVal = (val) => this.updateCondition(groupTempId, cond._tempId, 'value', val);
    const setOrg = (val) => this.updateCondition(groupTempId, cond._tempId, 'organizationId', val);

    const multiSelect = (label, list, loadFn) => (
      <Box onFocus={loadFn} sx={{ width: '100%' }}>
        <SimpleAutoCompleteMultiple
          label={label}
          options={list}
          stateName=""
          selected={list.filter(i => (cond.value ?? []).includes(i.id))}
          changeSelect={(_, selectedArr) => setVal((selectedArr ?? []).map(v => v.id))}
        />
      </Box>
    );

    switch (criteriaId) {
      case 5:
        return multiSelect('Tipo do Chamado', this.state.typeFilterList, this.getFilterType);
      case 6:
        return multiSelect('Prioridade', this.state.priorityFilterList, this.getFilterPriority);
      case 7:
        return multiSelect('Status', this.state.statusFilterList, this.getFilterStatus);
      case 8:
        return multiSelect('Origem', this.state.originFilterList, this.getFilterOrigin);
      case 9:
        return multiSelect('Grupo', this.state.groupFilterList, this.getFilterGroup);
      case 10:
        return multiSelect('Organização', this.state.organizationsFilterList, this.getFilterOrganizations);
      case 11:
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
            <RealSimpleAutoComplete
              label="Organização"
              options={this.state.organizationsFilterList}
              stateName=""
              size="small"
              loading={this.state.loadingOrganizationFilter}
              selected={() => this.state.organizationsFilterList.find(i => i.id == cond.organizationId) ?? null}
              changeSelect={(_, v) => {
                setOrg(v?.id ?? null);
                setVal([]);
                this.updateCondition(groupTempId, cond._tempId, 'categoryList', []);
                if (v?.id) this.getFilterCategoriesByOrg(v.id, groupTempId, cond._tempId);
              }}
              onFocus={this.getFilterOrganizations}
            />
            {cond.organizationId && (
              <Box onFocus={() => this.getFilterCategoriesByOrg(cond.organizationId, groupTempId, cond._tempId)} sx={{ width: '100%' }}>
                <SimpleAutoCompleteMultiple
                  label="Categoria"
                  options={cond.categoryList}
                  stateName=""
                  selected={cond.categoryList.filter(i => (cond.value ?? []).includes(i.id))}
                  changeSelect={(_, selectedArr) => setVal((selectedArr ?? []).map(v => v.id))}
                />
              </Box>
            )}
          </Box>
        );
      case 12:
        return multiSelect('Responsável', this.state.assignedUserFilterList, this.getFilterAssignedUser);
      default:
        return (
          <TextField
            label="Valor"
            fullWidth
            value={Array.isArray(cond.value) ? (cond.value[0] ?? '') : ''}
            onChange={(e) => setVal(e.target.value ? [e.target.value] : [])}
          />
        );
    }
  };

  renderFilterGroup = (group, groupIdx) => {
    const { filterFields, filters } = this.state;

    const usedCriteria = new Set(
      filters.flatMap(f => f.conditions.map(c => c.conditionCriteriaId)).filter(Boolean)
    );

    return (
      <Paper key={group._tempId} variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" fontWeight="bold">
              Grupo {groupIdx + 1}
            </Typography>
            <FormControl size="small" sx={{ minWidth: 90 }}>
              <Select
                value={group.logicalOperator}
                onChange={(e) => this.updateFilterGroup(group._tempId, 'logicalOperator', e.target.value)}
              >
                <MenuItem value="AND">E (AND)</MenuItem>
                <MenuItem value="OR">OU (OR)</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="caption" color="text.secondary">entre condições</Typography>
          </Box>
          <IconButton size="small" color="error" onClick={() => this.removeFilterGroup(group._tempId)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>

        {group.conditions.map((cond, condIdx) => (
            <Box key={cond._tempId} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1, flexWrap: 'wrap' }}>
              {condIdx > 0 && (
                <Typography variant="caption" sx={{ minWidth: 30, mt: 1.5, color: 'text.secondary', fontWeight: 'bold' }}>
                  {group.logicalOperator}
                </Typography>
              )}

              <FormControl sx={{ minWidth: 180 }}>
                <InputLabel>Campo</InputLabel>
                <Select
                  label="Campo"
                  value={cond.conditionCriteriaId ?? ''}
                  onChange={(e) => this.updateCondition(group._tempId, cond._tempId, 'conditionCriteriaId', e.target.value)}
                >
                  {filterFields
                    .filter(f => f.value === cond.conditionCriteriaId || !usedCriteria.has(f.value))
                    .map((f) => (
                      <MenuItem key={f.value} value={f.value}>{f.label}</MenuItem>
                    ))}
                </Select>
              </FormControl>

              <Box sx={{ flex: 1, minWidth: 180 }}>
                {this.renderConditionValue(group._tempId, cond)}
              </Box>

              <IconButton size="small" color="error" onClick={() => this.removeCondition(group._tempId, cond._tempId)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
        ))}

        {groupIdx < filters.length - 1 && (
          <Box sx={{ mt: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
            <Divider sx={{ flex: 1 }} />
            <FormControl size="small" sx={{ minWidth: 90 }}>
              <Select
                value={this.state.filterLogicalOperator}
                onChange={(e) => this.setState({ filterLogicalOperator: e.target.value })}
              >
                <MenuItem value="AND">E (AND)</MenuItem>
                <MenuItem value="OR">OU (OR)</MenuItem>
              </Select>
            </FormControl>
            <Divider sx={{ flex: 1 }} />
          </Box>
        )}

        <Button
          size="small"
          startIcon={<AddIcon />}
          onClick={() => this.addCondition(group._tempId)}
          sx={{ mt: 1 }}
        >
          Adicionar condição
        </Button>
      </Paper>
    );
  };

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const {
      loading, saving,
      title, active, groupBy, isDefault,
      columns, filters,
      openNotification, notificationVariant, notificationMessage,
      filtersOpen,
      shareMode, isTechnical, sharedUserIds, sharedTeamIds, userShareList, teamShareList,
      loadingUserShare, loadingTeamShare,
    } = this.state;

    const isEdit = Boolean(this.state.id);

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component="main" maxWidth="lg">
            <CssBaseline />

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <IconButton onClick={() => this.goBack()}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" fontWeight="bold">
                  {isEdit ? 'Editar quadro kanban' : 'Novo quadro kanban'}
                </Typography>
              </Box>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                onClick={this.handleSave}
                disabled={saving}
                sx={{ textTransform: 'none', borderRadius: 2, px: 3 }}
              >
                {saving ? 'Salvando...' : 'Salvar quadro'}
              </Button>
            </Box>

            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
                <CircularProgress />
              </Box>
            ) : (
              <Grid container spacing={3}>

                <Grid item xs={12}>
                  <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ color: 'text.primary' }}>
                        Informações gerais
                      </Typography>
                      <Tooltip title={isDefault ? 'Este quadro está marcado como padrão — será aplicado ao salvar' : 'Definir este quadro como padrão'}>
                        <span>
                          <Button
                            size="small"
                            variant={isDefault ? 'contained' : 'outlined'}
                            color={isDefault ? 'primary' : 'inherit'}
                            startIcon={isDefault ? <DefaultIconFilled /> : <DefaultIcon />}
                            onClick={this.handleSetDefault}
                            disabled={!isEdit}
                            sx={{ textTransform: 'none', borderRadius: 2 }}
                          >
                            {isDefault ? 'Quadro padrão' : 'Definir como padrão'}
                          </Button>
                        </span>
                      </Tooltip>
                    </Box>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={10}>
                        <TextField
                          label="Título do quadro"
                          fullWidth
                          required
                          value={title}
                          onChange={(e) => this.setState({ title: e.target.value })}
                        />
                      </Grid>
                      {/*<Grid item xs={12} sm={4}>
                        <FormControl fullWidth>
                          <InputLabel>Agrupamento</InputLabel>
                          <Select
                            label="Agrupamento"
                            value={groupBy}
                            onChange={(e) => this.setState({ groupBy: e.target.value })}
                          >
                            {GROUP_BY_OPTIONS.map((opt) => (
                              <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>*/}
                      <Grid item xs={12} sm={2}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={active}
                              onChange={(e) => this.setState({ active: e.target.checked })}
                              color="primary"
                            />
                          }
                          label="Ativo"
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>

                {!isTechnical && (
                  <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, color: 'text.primary' }}>
                        {this.props.intl.formatMessage({ id: 'kanban.board.share.section' })}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                        {this.props.intl.formatMessage({ id: 'kanban.board.share.description' })}
                      </Typography>
                      <RadioGroup
                        value={shareMode}
                        onChange={(e) => this.setState({ shareMode: parseInt(e.target.value, 10), sharedUserIds: [], sharedTeamIds: [] })}
                      >
                        <FormControlLabel value={1} control={<Radio />} label={this.props.intl.formatMessage({ id: 'kanban.board.share.private' })} />
                        <FormControlLabel value={4} control={<Radio />} label={this.props.intl.formatMessage({ id: 'kanban.board.share.all' })} />
                        <FormControlLabel value={3} control={<Radio />} label={this.props.intl.formatMessage({ id: 'kanban.board.share.teams' })} />
                        {shareMode === 3 && (
                          <Box sx={{ ml: 3, mt: 1, mb: 1 }}>
                            <RealSimpleAutoComplete
                              multiple
                              label={this.props.intl.formatMessage({ id: 'kanban.board.share.teams.placeholder' })}
                              options={teamShareList}
                              stateName="sharedTeamIds"
                              selected={teamShareList.filter(t => sharedTeamIds.includes(t.id))}
                              changeSelect={(_, selectedArr) => this.setState({ sharedTeamIds: (selectedArr ?? []).map(t => t.id) })}
                              onFocus={this.getShareTeams}
                              loading={loadingTeamShare}
                            />
                          </Box>
                        )}
                        <FormControlLabel value={2} control={<Radio />} label={this.props.intl.formatMessage({ id: 'kanban.board.share.users' })} />
                        {shareMode === 2 && (
                          <Box sx={{ ml: 3, mt: 1, mb: 1 }}>
                            <RealSimpleAutoComplete
                              multiple
                              label={this.props.intl.formatMessage({ id: 'kanban.board.share.users.placeholder' })}
                              options={userShareList}
                              stateName="sharedUserIds"
                              selected={userShareList.filter(u => sharedUserIds.includes(u.id))}
                              changeSelect={(_, selectedArr) => this.setState({ sharedUserIds: (selectedArr ?? []).map(u => u.id) })}
                              onFocus={this.getShareUsers}
                              loading={loadingUserShare}
                            />
                          </Box>
                        )}
                      </RadioGroup>
                    </Paper>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                      {this.renderSectionTitle('Colunas do quadro')}
                      <Tooltip title={columns.length >= 5 ? 'Limite de 5 colunas atingido' : ''}>
                        <span>
                          <Button
                            size="small"
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={this.addColumn}
                            disabled={columns.length >= 5}
                            sx={{ textTransform: 'none', borderRadius: 2 }}
                          >
                            Nova coluna
                          </Button>
                        </span>
                      </Tooltip>
                    </Box>

                    <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                      Cada coluna agrupa um ou mais status. Os chamados aparecem na coluna cujo status corresponder.
                    </Typography>

                    {columns.length === 0 ? (
                      <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
                        <Typography variant="body2">Nenhuma coluna configurada. Adicione ao menos uma.</Typography>
                      </Box>
                    ) : (
                      <DragDropContext onDragEnd={this.onColumnDragEnd}>
                        <Droppable droppableId="kanban-columns">
                          {(droppableProvided) => (
                            <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
                              {columns.map((col, index) => (
                                <Draggable key={String(col._tempId)} draggableId={String(col._tempId)} index={index}>
                                  {(provided, snapshot) => this.renderColumnCard(col, provided, snapshot)}
                                </Draggable>
                              ))}
                              {droppableProvided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    )}
                    <div ref={this.columnsEndRef} />
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                    <Box
                      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: filtersOpen ? 2 : 0, cursor: 'pointer' }}
                      onClick={() => this.setState((s) => ({ filtersOpen: !s.filtersOpen }))}
                    >
                      {this.renderSectionTitle('Filtros de exibição')}
                      <IconButton size="small">
                        {filtersOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                    </Box>

                    <Collapse in={filtersOpen}>
                      <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                        Defina condições para quais chamados aparecerão neste quadro. Sem filtros, todos os chamados são exibidos.
                      </Typography>

                      {filters.map((group, idx) => this.renderFilterGroup(group, idx))}

                      {filters.length === 0 && (
                        <Box sx={{ textAlign: 'center', py: 3, color: 'text.secondary' }}>
                          <Typography variant="body2">Nenhum filtro configurado — todos os chamados serão exibidos.</Typography>
                        </Box>
                      )}

                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={this.addFilterGroup}
                        sx={{ textTransform: 'none', borderRadius: 2, mt: 1 }}
                      >
                        Adicionar grupo de filtros
                      </Button>
                    </Collapse>
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, pb: 4 }}>
                    <Button
                      variant="outlined"
                      onClick={() => this.goBack()}
                      sx={{ textTransform: 'none', borderRadius: 2, px: 3 }}
                    >
                      Cancelar
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={this.handleSave}
                      disabled={saving}
                      sx={{ textTransform: 'none', borderRadius: 2, px: 3 }}
                    >
                      {saving ? 'Salvando...' : 'Salvar quadro'}
                    </Button>
                  </Box>
                </Grid>

              </Grid>
            )}

            {saving && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={notificationVariant}
              message={notificationMessage}
              isOpen={openNotification}
              toClose={this.closeNotification}
            />
            <CustomizedSnackbars
              variant="warning"
              message={this.state.columnWarning}
              isOpen={!!this.state.columnWarning}
              toClose={() => this.setState({ columnWarning: '' })}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}

KanbanBoardEdit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu:        state.headerMenu,
  userSession:       state.userSession,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(KanbanBoardEdit)));
